import {
  HeroSection,
  Listings,
  Guide,
  Advantages,
  Info,
  Roadmap,
  Team,
  Partners,
} from '../../components';

export const MainPage = () => {
  return (
    <>
      <HeroSection />
      <Listings />
      <Guide />
      <Advantages />
      <Roadmap />
      <Team />
      <Partners />
      <Info />
    </>
  );
};
